import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  yearsOfExperience: number = 0;

  ngOnInit(): void {
    this.yearsOfExperience = this.calculateTotalExperience();
  }

  calculateTotalExperience(): number {
    // Experience ranges
    const experienceRanges = [
      { start: new Date(2018, 5), end: new Date(2021, 7) }, // June 2018 → Aug 2021
      { start: new Date(2023, 0), end: new Date() }         // Jan 2023 → Present
    ];

    let totalMonths = 0;

    // Calculate all months across ranges
    experienceRanges.forEach(range => {
      totalMonths += this.monthDifference(range.start, range.end);
    });

    // Convert months to years
    const totalYears = totalMonths / 12;

    return Math.floor(totalYears); // 6.3 → 6
  }

  monthDifference(start: Date, end: Date): number {
    return (
      (end.getFullYear() - start.getFullYear()) * 12 +
      (end.getMonth() - start.getMonth())
    );
  }
}
